export const navs = [
    {
        title: '公司介绍',
        path: 'company'
    },
    {
        title: '发展历程',
        path: 'develop'
    },
    {
        title: '公司愿景',
        path: 'vision'
    },
    {
        title: '企业文化',
        path: 'culture'
    },
    {
        title: '企业荣誉',
        path: 'honor'
    }
]



// WEBPACK FOOTER //
// ./src/pages/about-sf/config.js